import { Pipe, PipeTransform } from '@angular/core';
import { fileNameTransform, FileNameTransformOptions } from '../transforms/file-name';

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {
  /**
   * Transforms a file into its file name
   * By default, removes the path
   * Can optionally remove the file extension, or only the file extensions that are valid
   *
   * @param {{ name: string; type?: string }} file
   * @param FileNameTransformOptions [args]
   * @returns {string}
   * @memberof FileNamePipe
   */
  transform(file: { name: string; type?: string }, args?: FileNameTransformOptions): string {
    return fileNameTransform(file, args);
  }
}
